import React, { useState } from 'react';
import { Bot, User } from 'lucide-react';
import useApi from '../hooks/useApi';

const GeminiAssistant = ({ transactions, accounts }) => {
    const [messages, setMessages] = useState([{ sender: 'ai', text: 'Olá! Como posso ajudar com as suas finanças hoje?' }]);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const { apiFetch } = useApi();

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!input.trim()) return;

        const userMessage = { sender: 'user', text: input };
        setMessages(prev => [...prev, userMessage]);
        const currentInput = input;
        setInput('');
        setLoading(true);

        try {
            const data = await apiFetch('/assistant', {
                method: 'POST',
                body: { 
                    prompt: currentInput,
                    transactions,
                    accounts 
                },
            });

            const aiMessage = { sender: 'ai', text: data.response };
            setMessages(prev => [...prev, aiMessage]);

        } catch (error) {
            console.error("Erro ao comunicar com o assistente:", error);
            const errorMessage = { sender: 'ai', text: 'Desculpe, ocorreu um erro. Tente novamente.' };
            setMessages(prev => [...prev, errorMessage]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col h-full max-h-[85vh] bg-white rounded-xl shadow-md">
            <div className="p-4 border-b">
                <h2 className="text-xl font-bold text-gray-800">Assistente Financeiro DFinAI</h2>
                <p className="text-sm text-gray-500">Converse com a IA para obter insights</p>
            </div>
            <div className="flex-1 p-4 overflow-y-auto space-y-4">
                {messages.map((msg, index) => (
                    <div key={index} className={`flex items-start gap-3 ${msg.sender === 'user' ? 'justify-end' : ''}`}>
                        {msg.sender === 'ai' && <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white shrink-0"><Bot size={20}/></div>}
                        <div className={`max-w-lg p-3 rounded-lg ${msg.sender === 'user' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'}`}>
                            <p className="text-sm" dangerouslySetInnerHTML={{ __html: msg.text.replace(/\n/g, '<br />') }}></p>
                        </div>
                         {msg.sender === 'user' && <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-gray-700 shrink-0"><User size={20}/></div>}
                    </div>
                ))}
                {loading && (
                     <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white shrink-0"><Bot size={20}/></div>
                        <div className="max-w-lg p-3 rounded-lg bg-gray-200 text-gray-800">
                           <div className="flex items-center space-x-1">
                                <span className="w-2 h-2 bg-gray-500 rounded-full animate-pulse delay-0"></span>
                                <span className="w-2 h-2 bg-gray-500 rounded-full animate-pulse delay-150"></span>
                                <span className="w-2 h-2 bg-gray-500 rounded-full animate-pulse delay-300"></span>
                           </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="p-4 border-t bg-gray-50 rounded-b-xl">
                <form onSubmit={handleSendMessage} className="flex items-center gap-2">
                    <input
                        type="text"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Pergunte algo sobre as suas finanças..."
                        className="flex-1 px-4 py-2 bg-gray-100 border-2 border-transparent rounded-lg focus:outline-none focus:border-blue-500"
                        disabled={loading}
                    />
                    <button type="submit" disabled={loading} className="px-4 py-2 font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:bg-blue-300">
                        Enviar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default GeminiAssistant;

